import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-image-text',
  templateUrl: './image-text.component.html',
  styleUrls: ['./image-text.component.css'],
})
export class ImageTextComponent implements OnInit {

  @Input() direction = '';
  @Input() image;
  @Input() imageClass = '';

  constructor() { }

  ngOnInit() {}

}
